import { render, staticRenderFns } from "./StudentStatus.vue?vue&type=template&id=065d315c&scoped=true&lang=pug&"
import script from "./StudentStatus.vue?vue&type=script&lang=ts&"
export * from "./StudentStatus.vue?vue&type=script&lang=ts&"
import style0 from "./StudentStatus.vue?vue&type=style&index=0&id=065d315c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065d315c",
  null
  
)

export default component.exports